export default {
  SM_ARIES_DOMAIN:
    process.env['NODE_ENV'] === 'development'
      ? 'https://ram-dev23.ose-dev39-vxbyr.cloud.marriott.com'
      : process.env['NGINX_URL'],
  SM_HYBRID_URL:
    process.env['NODE_ENV'] === 'development'
      ? 'https://ram-dev23.ose-dev39-vxbyr.cloud.marriott.com'
      : process.env['HYBRID_APP_URL'],
  SM_HOTEL_AMENITIES_ENDPOINT: '/aries-hotelinfo/v1/servicesAndAmenities.comp',
  SM_HOTEL_AMENITIES_VARIATION: '0.1',
  SM_HOTEL_INFORMATION_ENDPOINT: '/aries-hotelinfo/v1/arrivalInformation.comp',
  SM_HOTEL_INFORMATION_VARIATION: '0.1',
  SM_HOTEL_ACCESSIBILITY_ENDPOINT: '/aries-hotelinfo/v1/accessibilityDetails.comp',
  SM_HOTEL_ACCESSIBILITY_VARIATION: '0.2',
  SM_HOTEL_KEY_AMENITIES_ENDPOINT: '/aries-hotelinfo/v1/keyAmenities.comp',
  SM_HOTEL_KEY_AMENITIES_VARIATION: '0.1',
  UXL_RESOLVER_ENDPOINT:
    process.env['NODE_ENV'] === 'development'
      ? 'http://localhost:9090'
      : process.env['UXL_RESOLVER_ENDPOINT'] ??
        'https://ram-dev23.ose-dev39-vxbyr.cloud.marriott.com/hybrid-component-resolver',
  UXL_ENDPOINT: process.env['UXL_ENDPOINT'] ?? 'https://gatewaydsaptst1.marriott.com/v1/graph/query',
  DEFAULT_API_ACCEPT_LANGUAGE: process.env['DEFAULT_API_ACCEPT_LANGUAGE'] ?? 'en-US',
  SHOP_UXL_CLIENT_NAME: process.env['SHOP_UXL_CLIENT_NAME'] ?? 'phoenix_shop',
  HOTEL_GALLERY_INFORMATION_OPERATION_SIGNATURE: 'd92144ee3ce294918c1081cf13cf6654ed4166638d7a4709ceece9056eabff41',
  HOTEL_GALLERY_AMENITIES_OPERATION_SIGNATURE: 'e19f842483ad6454b0348d864a56a9e54cc6a06d4cd2297f855b2889d14fc880',
  HOTEL_GALLERY_PROPERTY_DETAILS_OPERATION_SIGNATURE:
    'a85dc6f4ac5fc78a5817a1f9fa54fc806737a1e1378025333c5dd240249b4daf',
};

/* below constants requires subdirectory prefix  */
export const NAVIGATION_URL_CONSTANTS = {
  SM_VIEW_HOTEL_WEBSITE_LINK: '/hotels/travel/',
};
